import { render, staticRenderFns } from "./boa-hora-status.vue?vue&type=template&id=7875e74b&scoped=true&"
import script from "./boa-hora-status.vue?vue&type=script&lang=ts&"
export * from "./boa-hora-status.vue?vue&type=script&lang=ts&"
import style0 from "./boa-hora-status.vue?vue&type=style&index=0&id=7875e74b&scoped=true&lang=css&"
import style1 from "./boa-hora-status.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7875e74b",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CPopoverTrigger: require('@chakra-ui/vue').CPopoverTrigger, CPopoverArrow: require('@chakra-ui/vue').CPopoverArrow, CPopoverCloseButton: require('@chakra-ui/vue').CPopoverCloseButton, CPopoverBody: require('@chakra-ui/vue').CPopoverBody, CPopoverContent: require('@chakra-ui/vue').CPopoverContent, CPopover: require('@chakra-ui/vue').CPopover, CFlex: require('@chakra-ui/vue').CFlex, CImage: require('@chakra-ui/vue').CImage})
